import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAnnotationDark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 8,
		cy: 8,
		r: 7,
		fill: "#253627"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.72989 5.38506V6.35862H9.70012C9.35494 5.69 8.71609 5.3046 7.87126 5.3046C6.38276 5.3046 5.26437 6.47931 5.26437 8.04023C5.26437 9.60115 6.38276 10.7759 7.87126 10.7759C8.81103 10.7759 9.58828 10.339 10.0026 9.65425C10.442 10.3357 11.2602 10.7517 12.2885 10.7517C13.9218 10.7517 15 9.60115 15 7.91954C15 4.11379 11.854 1 8 1C4.14598 1 1 4.18621 1 8.08046C1 11.8862 4.14598 15 8 15C9.85057 15 11.5161 14.2356 12.4333 13.4069L11.7092 12.6103C10.8966 13.3345 9.5931 13.9943 8 13.9943C4.70115 13.9943 2.00575 11.331 2.00575 8.08046C2.00575 4.74138 4.70115 2.00575 8 2.00575C11.2989 2.00575 13.9943 4.66897 13.9943 7.91954C13.9943 9.02989 13.3264 9.78621 12.2885 9.78621C11.3471 9.78621 10.6552 9.1908 10.6552 8.32184V5.38506H9.72989ZM7.95977 9.8908C6.99425 9.8908 6.27011 9.09425 6.27011 8.04023C6.27011 6.98621 6.99425 6.18966 7.95977 6.18966C8.92529 6.18966 9.64943 6.98621 9.64943 8.04023C9.64943 9.09425 8.92529 9.8908 7.95977 9.8908Z",
		fill: "#57965C"
	})]
});
export default SvgAnnotationDark;
